import { render } from "./TariffScreen.vue?vue&type=template&id=160e4bba&scoped=true"
import script from "./TariffScreen.vue?vue&type=script&lang=js"
export * from "./TariffScreen.vue?vue&type=script&lang=js"

import "./TariffScreen.vue?vue&type=style&index=0&id=160e4bba&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160e4bba"]])

export default __exports__